import { render, staticRenderFns } from "./VPicture.vue?vue&type=template&id=4cdf4c78&"
import script from "./VPicture.vue?vue&type=script&lang=js&"
export * from "./VPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports